<template>
  <div
    class="p-3 flex flex-col"
  >
    <Text
      align="center"
      size="xl"
      class="weight-400 pt-5 pb-5 self-center"
      italic
    >
      No TLFB in {{ project.name }}
    </Text>
    <div class="self-center">
      <Button
        @click="$emit('create-survey')"
        theme="secondary"
        size="xl"
        class="m-2"
      >
        Create TLFB Survey
      </Button>
    </div>
    <div class="self-center">
      <Button
        @click="unsyncProject"
        :disabled="unsyncing"
        theme="primary"
        size="md"
        class="m-2"
        :showSpinner="unsyncing"
      >
        Unsync REDCap Project
      </Button>
      <Text :class="{ hidden: !error }">{{ errorMessage }}</Text>
    </div>
  </div>
</template>
<script setup>
import Text from "./Text.vue"
import Button from "./Button.vue"
import { ProjectApi } from "../api"
import { ref, computed } from "vue"

const unsyncing = ref(false)
const errorMessage = ref("")
const error = computed(() => errorMessage.value !== "")

const emit = defineEmits(["create-survey", "project-unsynced"])

const props = defineProps({
  project: {
    type: Object,
    required: true
  }
})

async function unsyncProject() {
  unsyncing.value = true
  errorMessage.value = ""
  try {
    const response = await ProjectApi.destroy(props.project.id)
    if (response.status === 200) {
      emit("project-unsynced")
    }
  } catch (error) {
    errorMessage.value = "Error unsyncing REDCap Project. Please try again later."
  }
  unsyncing.value = false
}

</script>
